<template>
  <div
    :class="$style.column"
    hide-empty
  >
    <slot />
  </div>
</template>

<style module lang="scss">
.column {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
}
</style>
